<template>
    <div class="dk-wizard-lead-form-submission lg:tw-relative lg:tw-w-full tw-p-6">
        <div
            class="dk-wizard-lead-form-submission__body tw-pl-[2px] -tw-ml-[2px] lg:tw-relative lg:tw-h-[526px] tw-overflow-y-auto [&::-webkit-scrollbar]:max-lg:tw-hidden [&::-webkit-scrollbar]:lg:tw-bg-border-color [&::-webkit-scrollbar]:lg:tw-rounded-[10px] [&::-webkit-scrollbar]:lg:tw-w-2 [&::-webkit-scrollbar-thumb]:lg:tw-w-1 [&::-webkit-scrollbar-thumb]:lg:tw-bg-negative-subtle [&::-webkit-scrollbar-thumb]:hover:lg:tw-bg-slate-400 [&::-webkit-scrollbar-thumb]:active:lg:tw-bg-slate-600 [&::-webkit-scrollbar-thumb]:lg:tw-rounded-[10px] [&::-webkit-scrollbar-thumb]:lg:tw-border-2 [&::-webkit-scrollbar-thumb]:lg:tw-border-solid [&::-webkit-scrollbar-thumb]:lg:tw-border-transparent [&::-webkit-scrollbar-thumb]:lg:tw-bg-clip-content"
            :style="{ height: isMobile ? '' : `${customHeight}px` }"
        >
            <h6 class="dk-wizard-lead-form-submission__title tw-text-2xl tw-leading-lg tw-font-semibold tw-text-center">
                {{ $t('wizard-lead-form.insert-your-data') }}
            </h6>
            <lead-form-wrapper
                ref="leadFormWrapper"
                class="tw-mt-4 lg:tw-mr-4 lg:tw-mb-10"
                :form-id="formId"
                :form-data="formData"
                :is-project-forced="formData.project_forced"
                is-wizard-lead-form
                @mounted="onLeadFormMounted"
            />
        </div>
        <div
            class="dk-wizard-lead-form-submission__gradient max-lg:tw-hidden tw-absolute tw-bottom-6 tw-right-12 tw-h-[88px] lg:tw-h-14 tw-w-full tw-pointer-events-none tw-bg-gradient-to-t tw-from-white"
        ></div>
    </div>
</template>

<script>
/**
 * A lead form component
 */
export default {
    name: 'DkWizardLeadFormSubmission',
    components: {
        LeadFormWrapper: () => ({
            component: import(
                /* webpackChunkName: "LeadFormWrapper-vue" */ '@v4/common/components/organisms/LeadFormWrapper/LeadFormWrapper'
            ),
        }),
    },
    props: {
        /**
         * Selected color object
         */
        activeColor: {
            type: Object,
            default: () => ({}),
        },
        /**
         * Selected version object
         */
        selectedVersion: {
            type: Object,
            default: () => ({}),
        },
        /**
         * Selected optionals array
         */
        selectedOptionals: {
            type: Array,
            default: () => [],
        },
        /**
         * Form Id.
         * Available values: `submodel`, `version`, `social-lp`, `widget`, `advisor`
         * `editorial`, `multimodel`, `single-offer`, `offer-landing`, `compare`, `dkpromo`
         */
        formId: {
            type: String,
            required: true,
        },
        /**
         * Data to send when fetching the form configuration
         */
        formData: {
            type: Object,
            default: null,
        },
        /**
         * Make name
         */
        make: {
            type: String,
            default: '',
        },
        /**
         * Model name
         */
        model: {
            type: String,
            default: '',
        },
        promotionId: {
            type: String,
            default: '',
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            leadFormReady: false,
            customHeight: null,
        };
    },
    computed: {
        versionName() {
            const version = this.selectedVersion || {};
            return version.versionName || '';
        },
        basePrice() {
            const version = this.selectedVersion || {};
            return (version.pricing && version.pricing.basePrice) || 0;
        },
    },
    watch: {
        activeColor(color) {
            this.setLeadFormColorConfiguration(color);
        },
        selectedVersion(version) {
            this.setLeadFormVersionConfiguration(version);
        },
        selectedOptionals(optionals) {
            this.setLeadFormOptionalsConfiguration(optionals);
        },
    },
    mounted() {
        this.handleModalSizeOnDesktop();
    },
    methods: {
        onLeadFormMounted() {
            this.leadFormReady = true;

            if (this.activeColor) {
                this.setLeadFormColorConfiguration(this.activeColor);
            }
            if (this.promotionId) {
                this.setLeadFormPromotionId(this.promotionId);
            }

            this.setLeadFormVersionConfiguration(this.selectedVersion);
            this.setLeadFormOptionalsConfiguration(this.selectedOptionals);
        },
        setLeadFormColorConfiguration(color = {}) {
            this.$refs.leadFormWrapper.setLeadFormHiddenField('dkwp[colorDescription]', color.description || '');
            this.$refs.leadFormWrapper.setLeadFormHiddenField('dkwp[colorCode]', color.baseColourHex || '');
            this.$refs.leadFormWrapper.setLeadFormHiddenField('dkwp[colorType]', color.group || '');
            this.$refs.leadFormWrapper.setLeadFormHiddenField('dkwp[colorCalculated]', color.primaryHex || '');
            this.$refs.leadFormWrapper.setLeadFormHiddenField(
                'dkwp[secondaryColorCalculated]',
                color.secondaryHex || ''
            );
        },
        setLeadFormVersionConfiguration(version) {
            this.$refs.leadFormWrapper.setLeadFormHiddenField('dkwp[vehicleId]', version.versionHistoricalId);
        },
        setLeadFormOptionalsConfiguration(optionals = []) {
            const optionalsString = optionals.length ? optionals.map((item) => item.description).join() : null;
            const finalPrice = optionals.reduce((a, b) => a + b.price, this.basePrice);

            this.$refs.leadFormWrapper.setLeadFormHiddenField('dkwp[price]', finalPrice.toString());
            this.$refs.leadFormWrapper.setLeadFormHiddenField('dkwp[optional]', optionalsString);
        },
        setLeadFormPromotionId(promotionId) {
            this.$refs.leadFormWrapper.setLeadFormHiddenField('dkwp[promotionId]', promotionId);
        },
        handleModalSizeOnDesktop() {
            const modalMaxSize = 800;
            const defaultScrollSize = 526;
            if (window.innerHeight < modalMaxSize) {
                this.customHeight = defaultScrollSize - (modalMaxSize - window.innerHeight);
            }
        },
    },
};
</script>
